import { SessionTimeoutProps, sessionTimeoutState } from "@mirage/components/sessionTimeout/SessionTimeout";
import { useCallback } from "react";
import { useSetRecoilState } from "recoil";

const useSessionTimeout = () => {
    const setState = useSetRecoilState(sessionTimeoutState);

    const setSessionTimeout = useCallback(
        (props: Omit<SessionTimeoutProps, "open">) => {
            setState((prev) => {
                return {
                    ...prev,
                    open: true,
                    timeoutIn: props.timeoutIn,
                };
            });
        },
        [setState]
    );
    return [setSessionTimeout];
};

export default useSessionTimeout;
